<template>
  <div class="game-container">
<!--    &lt;!&ndash; 悬浮返回按钮 &ndash;&gt;-->
<!--    <div class="floating-back-button" @click="handleBack">-->
<!--      <i class="icon-back"></i>-->
<!--    </div>-->

    <!-- 内容区域 -->
    <div v-if="url" class="content-wrapper">
      <iframe
          v-if="!type"
          ref="iframe"
          class="game-iframe"
          scrolling="auto"
          frameborder="0"
          :src="url"
          allowfullscreen
      ></iframe>
      <iframe
          v-else
          :src="url"
          ref="iframe"
          class="game-iframe"
          scrolling="auto"
          frameborder="0"
          allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
document.addEventListener('plusready', function() {
  // 设置状态栏样式
  plus.navigator.setStatusBarStyle('light'); // 状态栏文字颜色：light/light-content
  plus.navigator.setStatusBarBackground('transparent'); // 状态栏背景透明

  // 隐藏状态栏（可选，根据需求选择）
  // plus.navigator.setFullscreen(true);

  // 确保内容不被状态栏覆盖
  adjustForStatusBar();

  // 监听返回按钮（如果需要）
  plus.key.addEventListener('backbutton', function() {
    plus.webview.currentWebview().close();
  });
});

// 调整内容区域避免被状态栏覆盖
function adjustForStatusBar() {
  var statusBarHeight = plus.navigator.getStatusbarHeight();
  var content = document.querySelector('.content');
  if (content) {
    content.style.paddingTop = statusBarHeight + 'px';
  }
}

// 监听窗口变化（横竖屏切换）
window.addEventListener('resize', adjustForStatusBar);
</script>

<script>
export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
      type: null,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;

    // 打开代理
    if (query.dailiD == 1) {
      that.getAgentLoginUrl();
      return;
    }
    if (query.pay_url) {
      that.url = query.pay_url;
      return;
    }
    // 打开客服
    if (query.dailiD == 2) {
      that.getservicerurl();
      return;
    }

    if (query.app == 1) {
      that.type = 'app';
      that.url = that.$store.state.appInfo.ios_download_url;
      return;
    }

    if (query.name) {
      that.goGamePage(query.name, query.type, query.code);
    }
  },
  methods: {
    // 处理返回按钮点击
    handleBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/');
      }
    },

    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },

    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },

    // 打开游戏
    goGamePage(name, type, code) {
      let that = this;
      that.$apiFun
          .post('/api/getGameUrl', {
            plat_name: name,
            game_type: type || 0,
            game_code: code,
            is_mobile_url: 1
          })
          .then(res => {
            if (res.code != 200) {
              that.$parent.showTost(0, res.message);
            }
            if (res.code == 200) {
              that.url = res.data.url;
            }
          })
          .catch(res => {});
    },
  },
  mounted() {
    // 设置全屏样式
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    // 监听返回键 (兼容5+ App)
    if (window.plus && plus.key) {
      plus.key.addEventListener('backbutton', this.handleBack);
    }
  },
  beforeDestroy() {
    // 恢复页面滚动
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    // 移除返回键监听
    if (window.plus && plus.key) {
      plus.key.removeEventListener('backbutton', this.handleBack);
    }
  },
  updated() {
    let that = this;
    if (that.$refs.iframe && that.url) {
      that.$refs.iframe.contentWindow.location.replace(that.url);
    }
  },
};
</script>

<style lang="scss" scoped>
.game-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: #000;
  overflow: hidden;

  .content-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .game-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
  }

  .floating-back-button {
    position: fixed;
    top: 15px;
    left: 15px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    cursor: pointer;
    transition: all 0.3s;

    &:active {
      transform: scale(0.9);
    }

    .icon-back {
      display: inline-block;
      width: 20px;
      height: 20px;
      border-left: 3px solid #fff;
      border-bottom: 3px solid #fff;
      transform: rotate(45deg);
      margin-right: 5px;
    }
  }

  @media (max-width: 768px) {
    .floating-back-button {
      top: 10px;
      left: 10px;
      width: 35px;
      height: 35px;

      .icon-back {
        width: 16px;
        height: 16px;
      }
    }
  }
}
</style>